import React from 'react';
import { Spin } from 'antd';
import { Button } from '@/components/ui/Button';
import Link from '@/components/ui/Link';
import { Container } from '@/components/ui/Container';
import StatusBadge from '@/components/ui/StatusBadge';
import { useLeaveDetailPanel } from '../hooks/useLeaves';
import {
    DetailLabel,
    DetailValue,
    DetailPanelLoading,
    DetailPanelContentWrap,
    DetailPanelScroll,  
    DetailPanelFooter,
    DetailPanelFooterBtn,
    DetailValueInherit,
} from '@/pages/inside/tenant/style';

const LeaveDetailPanel = ({ leaveId, onApproveRequested, onRejectRequested }) => {
    const {
        leave,
        isLoading,
        isError,
        canUpdate,
        isPending,
        formatDate,
        formatDateTime,
        capFirst,
    } = useLeaveDetailPanel(leaveId);

    if (!leaveId) return null;
    if (isLoading) {
        return (
            <DetailPanelLoading>
                <Spin size="large" />
            </DetailPanelLoading>
        );
    }
    if (isError || !leave) {
        return (
            <Container $marginBottom="24px">
                <DetailValueInherit>Failed to load leave details.</DetailValueInherit>
            </Container>
        );
    }

    return (
        <DetailPanelContentWrap>
            <DetailPanelScroll>
                <Container $marginBottom="24px" $display="flex" $alignItems="flex-start" $gap="12px">
                    <DetailLabel>Email :</DetailLabel>
                    <DetailValue>
                        <Link href={`mailto:${leave.userEmail}`}>{leave.userEmail ?? '—'}</Link>
                    </DetailValue>
                </Container>
                <Container $marginBottom="24px" $display="flex" $alignItems="flex-start" $gap="12px">
                    <DetailLabel>Type :</DetailLabel>
                    <DetailValue>{capFirst(leave.type ?? '—')}</DetailValue>
                </Container>
                <Container $marginBottom="24px" $display="flex" $alignItems="flex-start" $gap="12px">
                    <DetailLabel>Start date :</DetailLabel>
                    <DetailValue>{formatDate(leave.startDate)}</DetailValue>
                </Container>
                <Container $marginBottom="24px" $display="flex" $alignItems="flex-start" $gap="12px">
                    <DetailLabel>End date :</DetailLabel>
                    <DetailValue>{formatDate(leave.endDate)}</DetailValue>
                </Container>
                <Container $marginBottom="24px" $display="flex" $alignItems="flex-start" $gap="12px">
                    <DetailLabel>Status :</DetailLabel>
                    <DetailValue>
                        <StatusBadge status={leave.status} />
                    </DetailValue>
                </Container>
                {leave.reason && (
                    <Container $marginBottom="24px" $display="flex" $alignItems="flex-start" $gap="12px">
                        <DetailLabel>Reason :</DetailLabel>
                        <DetailValue>{leave.reason}</DetailValue>
                    </Container>
                )}
                <Container $marginBottom="24px" $display="flex" $alignItems="flex-start" $gap="12px">
                    <DetailLabel>Created at :</DetailLabel>
                    <DetailValue>{formatDateTime(leave.createdAt)}</DetailValue>
                </Container>
            </DetailPanelScroll>
            {isPending && canUpdate && (
                <DetailPanelFooter>
                    <DetailPanelFooterBtn>
                        <Button
                            $primary
                            $blackOnLight
                            block
                            $size="16px"
                            $padding="8px 16px"
                            onClick={() => onApproveRequested?.()}
                        >
                            Approve
                        </Button>
                    </DetailPanelFooterBtn>
                    <DetailPanelFooterBtn>
                        <Button
                            block
                            $size="16px"
                            $padding="8px 16px"
                            style={{ backgroundColor: 'red', border: 'none' }}
                            onClick={() => onRejectRequested?.()}
                        >
                            Reject
                        </Button>
                    </DetailPanelFooterBtn>
                </DetailPanelFooter>
            )}
        </DetailPanelContentWrap>
    );
};

export default LeaveDetailPanel;
